import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SideTab } from '../Components/SideTab';
import { ActionSuggestion } from '../Components/ActionSuggestion';
import { UserActionSuggestionsPanel } from '../Panels/UserActionSuggestionsPanel';
import { UserActionSuggestionRepository } from '../../MedicareProAPI/Repositories/User/UserActionSuggestionRepository';

export default function ActionSuggestionsButton(props) {
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(0);

  const userActionSuggestionRepository = React.useMemo(() => {
    const repo = new UserActionSuggestionRepository();
    repo.setAccessToken(props.userAccessToken);
    return repo;
  }, [props.userAccessToken]);

  const handleCounter = () => {
    setCount((prev) => Math.max(prev - 1, 0));
  };

  useEffect(() => {
    userActionSuggestionRepository
      .getUserActionSuggestionsCountBy(props.userId, { criteria: { status: 'pending' } })
      .then((response) => {
        setCount(response.total);
      });
  }, [props.userAccessToken]);
  console.log(props.nav);
  return (
    <>
      {props.nav === 'topNav' && (
        <a
          onClick={(e) => {
            setShow(true);
          }}
          className="nav-link"
          href="#"
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip placement="right">AI Suggestions</Tooltip>}
          >
            <i className="fad fa-sparkles mt-1 text-lavender" style={{ fontSize: '13pt' }}></i>
          </OverlayTrigger>

          {count > 0 && <div className="badge badge-lavender align-top pendingBadge">{count}</div>}
        </a>
      )}
      {props.nav === 'sideNav' && (
        <div
          className="text-lavender"
          onClick={(e) => {
            setShow(true);
          }}
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip placement="right">AI Suggestions</Tooltip>}
          >
            <i
              className={`sideNavIcon fad fa-sparkles mr-3 ${props.navSize === 'small' ? 'fa-lg' : ''}`}
            ></i>
          </OverlayTrigger>
          <span className={`sideNavBig ${props.navSize === 'small' ? 'd-none' : ''} `}>
            AI Suggestions
          </span>
          {count > 0 && <div className="badge badge-lavender sideNavBig float-right">{count}</div>}
        </div>
      )}

      <SideTab
        size="mg"
        position="right"
        title="AI Suggestions"
        onClose={(e) => setShow(false)}
        show={show}
        scroll={true}
        id={'sidetab-ai-suggestions'}
      >
        {show && (
          <UserActionSuggestionsPanel
            userAccessToken={props.userAccessToken}
            userId={props.userId}
            usersAgencyId={props.usersAgencyId}
            directUplineId={props.directUplineId}
            absoluteUplineId={props.absoluteUplineId}
            staffId={props.staffId}
            onUpdate={handleCounter}
          />
        )}
      </SideTab>
    </>
  );
}
